import { AppLayout } from 'layouts';
import { DefaultChatroom } from 'features/chat';
import { useChatroomsSearchParams, useNavigateToCreateChat, useRedirectToChatroom } from '../hooks';

const PageChatrooms = () => {
  const redirectToChatroom = useRedirectToChatroom();
  const navigateToCreateChat = useNavigateToCreateChat();
  const searchParamsOptions = useChatroomsSearchParams();

  return (
    <AppLayout fitCenterContent>
      <DefaultChatroom
        onCreateChatClicked={navigateToCreateChat}
        redirectToChatroom={redirectToChatroom}
        searchParamsOptions={searchParamsOptions}
      />
    </AppLayout>
  );
};

export default PageChatrooms;
